export default __webpack_public_path__ + "static/media/bbc-logo-white.ee47e9db.png";